import React from 'react';
import type { Icon } from './types';

export const Walking: Icon = ({ className }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="12"
        height="20"
        viewBox="0 0 12 20"
        fill="none"
        className={className}
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0.725205 19.4686L1.61201 20.0011L5.11996 14.6736L4.23315 14.1411L0.725205 19.4686ZM6.60956 13.3136L4.51432 11.5751V8.01665C4.51432 7.45715 4.9758 7.00165 5.56194 7.00165C6.14809 7.00165 6.60956 7.45715 6.60956 8.01665V13.3136ZM7.65726 8.01665C7.65726 6.90365 6.72016 6.00165 5.55468 6.00165C4.90987 6.00165 4.34364 6.28365 3.95654 6.71865L3.9424 6.70765L0.537109 11.0901L1.38673 11.6861L3.46678 9.02015V12.0351L8.70488 16.3586V19.7476H9.7525V15.9166L9.76088 15.9071L7.65726 14.1811V8.01665ZM5.44355 0.998047C6.27072 0.998047 6.94385 1.67105 6.94385 2.49805C6.94385 3.32505 6.27072 3.99805 5.44355 3.99805C4.61639 3.99805 3.94325 3.32505 3.94325 2.49805C3.94325 1.67105 4.61639 0.998047 5.44355 0.998047ZM5.44335 4.99805C6.82413 4.99805 7.94335 3.87855 7.94335 2.49805C7.94335 1.11755 6.82413 -0.00195312 5.44335 -0.00195312C4.06257 -0.00195312 2.94335 1.11755 2.94335 2.49805C2.94335 3.87855 4.06257 4.99805 5.44335 4.99805ZM9.45617 10.3908L8.71917 11.1013L10.7091 12.9818L11.4461 12.2713L9.45617 10.3908Z"
            fill="#3659E3"
        />
    </svg>
);
